import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CourseAnalyticsComponent } from '@app/main/analytics/course/course-analytics.component';
import { LearnspaceAnalyticsComponent } from '@app/main/analytics/learnspace/learnspace-analytics.component';
import { HubStatComponent } from './hub-stats/hub-stats.component';
import { CurrentContextResolver } from '@app/context-resolver/context-resolver';
const routes: Routes = [
  {
    path: ':lsId/courses/:courseId',
    component: CourseAnalyticsComponent,
    resolve: {
      context: CurrentContextResolver
    }
  },
  {
    path: ':lsId',
    component: LearnspaceAnalyticsComponent,
    resolve: {
      context: CurrentContextResolver
    }
  },
  {
    path: '',
    component: HubStatComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AnalyticsRoutingModule {}
